import { atom } from 'recoil'
import { User } from 'types/entity'
export const AuthState = atom<User['authorityCode']>({
  key: 'auth',
  default: 'GENERAL'
})
